export default __webpack_public_path__ + "static/media/watermarked-08af277b-3fb0-4920-a9b5-d40e667a2567.7f46f258.png";